import { useTranslation } from 'react-i18next'
import { SlidersHorizontal } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface TwinTestCutFilterTriggerProps {
  activeLabel: string | null
  onClick: () => void
  disabled?: boolean
}

export function TwinTestCutFilterTrigger(props: TwinTestCutFilterTriggerProps) {
  const { activeLabel, onClick, disabled = false } = props

  const { t } = useTranslation('app')

  const isActive = Boolean(activeLabel)

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      disabled={disabled}
      onClick={onClick}
      data-testid="thread-command-filters"
      className={cn(
        'h-10 w-full justify-start gap-2 rounded-lg px-4 text-sm font-medium',
        isActive && 'border-primary/40 bg-primary/5',
      )}
    >
      <SlidersHorizontal className="h-4 w-4" />
      {t('audiences.filters')}
      {isActive ? (
        <span
          className="ml-auto truncate rounded-full bg-primary px-1.5 text-xs font-bold text-primary-foreground"
          data-testid="thread-command-filters-active"
        >
          {activeLabel}
        </span>
      ) : null}
    </Button>
  )
}
